import { render } from "./form-add-account.vue?vue&type=template&id=1638ed58"
import script from "./form-add-account.vue?vue&type=script&lang=js"
export * from "./form-add-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__